import { string, array, object, boolean } from "@src/libs/yup";

export const zipcodeValidation = string().zipcode(
	"Please enter a valid zipcode"
);

export const signupAsProValidation = object({
	input: object({
		enableTextNotifications: boolean().required(),
		email: string()
			.email("Please enter a valid email")
			.required("Please enter an email"),
		phone: string()
			.phone("Please enter a valid phone number")
			.required("Please enter a phone number"),
		password: string().required("Please enter a password"),
		zipcode: string()
			.zipcode("Please enter a valid zipcode")
			.required("Please enter a zipcode"),
		onboardingService: string().required(),
		services: array().of(string().objectid()).default([]),
	}).required(),
});

export const signupWithFbValidation = object({
	access_token: string().required(),
	input: object({
		zipcode: string()
			.zipcode("Please enter a valid zipcode")
			.required("Please enter a zipcode"),
		onboardingService: string().required(),
		services: array().of(string().objectid()).default([]),
	}).required(),
});

export const signupWithGoogleValidation = object({
	access_token: string().required(),
	input: object({
		zipcode: string()
			.zipcode("Please enter a valid zipcode")
			.required("Please enter a zipcode"),
		onboardingService: string().required(),
		services: array().of(string().objectid()).default([]),
	}).required(),
});
